if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('drawer-component[data-drawer="cart"]');
      this.submitButton = this.querySelector('[type="submit"]') || this.querySelector("#addAllToCart");
      if (document.querySelector('drawer-component[data-drawer="cart"]')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const enableAddToCartAnimation = theme.settings.enable_add_to_cart_animation;
      const atbDuration = parseInt(theme.settings.add_to_cart_animation_duration);
       
      const atcAnimationSvg = theme.settings.add_to_bag_svg;
      const openCartDrawer = theme.settings.open_cart_drawer_on_atb ;

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const overlayProgressBg = document.createElement('div');
      const overlaySvg = document.createElement('div');
      
      if(enableAddToCartAnimation) {
        this.submitButton.querySelector('span').classList.add('visibility-hidden');
        overlayProgressBg.classList.add('loading-progress');
        overlaySvg.classList.add('overlay-tick');
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            this.submitButton.setAttribute('disabled', true);
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          
          let clickedIndex = parseInt(localStorage.getItem('clickedIndex'));
          if (document.body.classList.contains('template-product'))
          clickedIndex = 0;

          let cardElement = document.querySelector('.card[product-handle="'+response.handle+'"],.product[product-handle="'+response.handle+'"]');
          let productCats = "";
          if (cardElement)
          productCats = cardElement.getAttribute('product-cats');

          // send to GTM
          if(window.handleCart) window.handleCart(response, "add_to_cart", clickedIndex, productCats);
          // Cart after change
          let body = JSON.stringify({
            line: "1"
          });

          this.triggerBloomreachPixel(response);

          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => {
              return response.text();
            })
            .then((state) => {
              const parsedState = JSON.parse(state);
              let cartAfter = parsedState.items;
              cartAfter = prepareItems(cartAfter);
              localStorage.setItem('cartItems', JSON.stringify(cartAfter));
            }) 
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          var isCartPage = window.location.href.indexOf("/cart") !== -1 ? true : false;
          if (quickAddModal) {
            this.cart.renderContents(response, openCartDrawer);
            if(theme.settings.open_cart_drawer_on_atb)  quickAddModal.hide(true);
          }
          else if (isCartPage) {
            /* If we're on the cart page 
             * we will fetch the content of the cart page after each Add to Bag submission 
             * then we'll update the sections that we want
             */
            fetch(window.location.href).then((response) => {
              return response.text();
            })
              .then((html) => {
                var data = document.createElement("div");
                data.innerHTML = html;

                // Elements to update
                var elemets = {
                  header: ".main-cart-header-wrapper",
                  cartItems: ".main-cart-items-wrapper",
                  footer: ".cart__footer-wrapper",
                  cartCount: ".cart-count-bubble"
                }

                // getting the updated data
                var header = data.querySelector(elemets.header);
                var cartItems = data.querySelector(elemets.cartItems);
                var footer = data.querySelector(elemets.footer);
                var cartCount = data.querySelector(elemets.cartCount);

                // updating the page
                document.querySelector(elemets.header).innerHTML = header.innerHTML;
                document.querySelector(elemets.cartItems).innerHTML = cartItems.innerHTML;
                document.querySelector(elemets.footer).innerHTML = footer.innerHTML;
                document.querySelector(elemets.cartCount).innerHTML = cartCount.innerHTML;
              })
              .catch((err) => {
                console.log('Something went wrong', err);
              });
          }
          else {

            this.cart.renderContents(response, openCartDrawer);

          }
          if(enableAddToCartAnimation) {
            this.submitButton.appendChild(overlayProgressBg);
            this.submitButton.appendChild(overlaySvg);

            setTimeout(() => {
              overlayProgressBg.classList.add('animate-loading');
              overlaySvg.innerHTML = atcAnimationSvg;
            }, 0);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

          if(enableAddToCartAnimation) {
            setTimeout(() => {
              overlayProgressBg.classList.add('animate-unloading');
              overlaySvg.remove();
              this.submitButton.querySelector('span').classList.remove('visibility-hidden');
              setTimeout(() => {
                if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                overlayProgressBg.remove();
              }, atbDuration);
          }, atbDuration);
          }
        });
    }

    triggerBloomreachPixel(response) {
      if(response && typeof response === "object") {
        let { id, sku, title } = response;
        sku = sku || "";
        title = title || "";
        
        if(!id || typeof id !== 'number') {
          console.error("Couldn't trigger Bloomreach Add-To-Cart Pixel. Product ID is invalid");
          return;
        }

        if(!window.BrTrk) {
          console.error("Bloomreach Pixel isn't defined");
          return;
        }

        let trackingObject = {
          "acct_id": "8146",
          "prod_id": id,
          "sku" : sku,
          "etype": "click-add",
          "prod_name": title
        }

        const isCollectionPage = window.location.pathname.includes("/collections/");
        const collectionID = isCollectionPage ? window.location.pathname : null;
        const customerId = window.SHG_CUSTOMER?.id || null;

        if(collectionID) trackingObject["prod_collection_id"] = collectionID;
        if(customerId) trackingObject["user_id"] = customerId;

        // trigger Bloomreach pixel event
        document.dispatchEvent(new CustomEvent('brCartClickAdd', {
          bubbles: true,
          detail: trackingObject
        }));
      }
    }


    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        //Remove the max quantity error if the form has other error to show
        const errQtyMsg = document.querySelector(".product__info-container .quantity__error-message-wrapper--hidden");
        errQtyMsg.style.display = 'none';
        this.errorMessage.textContent = errorMessage;
        // Hide loading animation if there is an error and animation is enabled in the settings
        if (theme.settings.enable_add_to_cart_animation) this.submitButton.classList.remove('loading'); 
      }
    }
  });
}
